import React from "react";
import Modal from "antd/lib/modal";
import { Button } from "antd";
import VideoPlayer from "./VideoPlayer";

const VideoPlayerModal = ({ isShowing, file, updateIsShowingVideoPlayer }) => {
	const handleCancel = () => {
		updateIsShowingVideoPlayer(false);
	};
	const memoized = React.useMemo(() => {
		const videoJsOptions = {
			autoplay: false,
			controls: true,
			errorDisplay: false,
			sources: [
				{
					src: file,
					type: file && file.length > 0 ? file[0]?.type : "video/mp4",
				},
			],
		};

		const videoPlayerStyle = {
			objectFit: "cover",
			margin: "0 auto",
			height: 700,
			width: "100%",
		};
		if (!isShowing) return null;
		return <VideoPlayer styleConfig={videoPlayerStyle} options={videoJsOptions} />;
	}, [isShowing, file]);
	if (!isShowing) {
		return null;
	}

	return (
		<Modal
			style={{ position: "relative" }}
			open={isShowing}
			onCancel={handleCancel}
			maskClosable={false}
			className="video-player-modal"
			footer={[
				<Button
					style={{ marginTop: 16, width: "100%" }}
					key={"video-player-close-key"}
					type="primary"
					onClick={() => handleCancel()}
				>
					Close
				</Button>,
			]}
			fullscreen
			destroyOnClose={false}
			forceRender
			width={1024}
		>
			{memoized}
		</Modal>
	);
};

export default VideoPlayerModal;
